import { render, staticRenderFns } from "./artworkService.vue?vue&type=template&id=354fc04f&"
import script from "./artworkService.vue?vue&type=script&lang=js&"
export * from "./artworkService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports